function bindTrixOnChange() {
  document.addEventListener('trix-change', (trix) => {
    if (!!trix.target.dataset.updateTarget) {
      document.querySelector(trix.target.dataset.updateTarget).innerHTML = trix.target.value;
    }
  });
}

$(() => { bindTrixOnChange() });
document.addEventListener("turbo:load", bindTrixOnChange);